import React, { Component, useState } from 'react';
import { connect } from 'react-redux';

import { Row, Col } from 'reactstrap';

import { callApi, formatAmount } from '../../utils';
import { showError } from '../../actions/notificationActions';

import SearchForm from '.././SearchForm';
import DataTable, { PageHeader } from '../DataTable';

class List extends Component {
  state = {
    rows: [],
    query: '',
    page: 1,
    limit: 300,
    loading: false,
    pages: 1,
  };

  componentWillMount() {
    this.loadGateways();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  loadGateways = (e) => {
    // Event may be passed in from search form
    if (e) e.preventDefault();

    const { query, page, limit } = this.state;

    this.startLoad();
    callApi(`/service-providers?q=${query}&page=${page}&limit=${limit}`)
      .then(({ data = [], meta = {} }) => {
        this.setState({ loading: false, rows: data, pages: meta.pages });
        this.scrollToTop();
      })
      .catch((err) => {
        this.stopLoad();
        this.props.dispatch(showError(err));
      });
  };

  setPage = (page) => {
    if (page) {
      this.setState({ page }, () => {
        this.loadGateways();
      });
    }
  };

  getBalance = (id) => {
    callApi(`/service-providers/${id}/wallet`)
      .then(({ data }) => formatAmount(data.balance))
      .catch((error) => '-.--');
  };

  setQuery = (e) => {
    this.setState({ query: e.target.value });
  };

  openTransaction = (id) => {
    // this.props.dispatch(openTransactionModal({id}));
    this.props.history.push(`/gateways/${id}`);
  };

  render() {
    const { query, rows, page, loading, limit, pages } = this.state;

    const hasResults = rows.length > 0;
    return (
      <div className="container-fluid">
        <Row className="mt-3 mt-md-4">
          <Col xs={12}>
            <PageHeader
              title="Service Gateways"
              subtitle={<>Gateways - Page {page}</>}
            >
              <SearchForm
                value={query}
                onChange={this.setQuery}
                onSearch={this.loadGateways}
                loading={loading}
              />
            </PageHeader>

            <DataTable
              minWidth={800}
              loading={loading}
              page={page}
              total={pages}
              onPageChange={this.setPage}
              showPagination={hasResults}
            >
              <thead className="text-primary">
                <tr>
                  <th>No.</th>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Balance</th>
                  <th>Active</th>
                </tr>
              </thead>

              <tbody>
                {rows.map((t, i) => (
                  <tr onClick={() => this.openTransaction(t.code)} key={t.code}>
                    <td>{loading ? '—' : i + 1 + (page - 1) * limit}</td>
                    <td>{t.code}</td>
                    <td style={{ width: '50%' }}>{t.name}</td>
                    <td>
                      <Balance id={i + 1 + (page - 1) * limit} />
                    </td>
                    <td>{t.active ? 'YES' : 'NO'}</td>
                  </tr>
                ))}
              </tbody>
            </DataTable>
          </Col>
        </Row>
      </div>
    );
  }
}

function Balance({ id }) {
  const [balance, setBalance] = useState('-.--');

  const getWallet = (id) => {
    callApi(`/service-providers/${id}/wallet`)
      .then(({ data }) => {
        setBalance(formatAmount(data.balance));
      })
      .catch((error) => '-.--');
  };

  getWallet(id);

  return <span>{balance}</span>;
}

export default connect()(List);
